import { useTranslation } from 'next-i18next';

const GoogleRecaptchaText: React.FC = () => {
  const { t } = useTranslation('recaptcha');
  return (
    <div className="text-container">
      {t('text1')}
      <a href="https://policies.google.com/privacy"> {t('text2')}</a>
      {t('text3')}
      <a href="https://policies.google.com/terms">{t('text4')}</a>
      {t('text5')}
      <style jsx>{`
        .text-container {
          margin-top: 10px;
          font-size: 0.875rem;
          color: #707070;
        }
        a {
          color: blue;
        }
      `}</style>
    </div>
  );
};

export default GoogleRecaptchaText;
